'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - Cabin tab - Grid
 */
var FlightCabinGridTransformerFactory = function FlightCabinGridTransformerFactory(DataTransformer, mergeScenarioDataService, bookingsIntakeTransformationService, effectiveValueService, momentService, userActionService, hepService, dtdFilteringService, flightLiveDataService, trendComputingService, userService, metricReferenceDataService) {
  function FlightCabinGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['cabin'];
    this.targetType = ['cabin-flight-analysis', 'profile-chart-add-flight-panel-dropdowns'];
    this.priority = 1;
  }
  FlightCabinGridTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightCabinGridTransformer.constructor = FlightCabinGridTransformer;
  FlightCabinGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.targetType.indexOf(targetType) > -1 && this.sourceType.indexOf(sourceType) > -1;
  };
  FlightCabinGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightCabinGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType.join('-') + '-' + this.targetType.join('-');
  };
  function setEffectiveValues(entry) {
    var effective = effectiveValueService.calculateAll(entry, 'cabin-flight-analysis');
    _.assign(entry, effective);
  }
  function setLastRefreshTime(timeStamp) {
    if (timeStamp) {
      flightLiveDataService.setLastRefreshTime('cabin-flight-analysis', momentService.of(timeStamp, momentService.FIELD.EVENT_TIME_STAMP));
    }
  }
  function getInvCabinAvailability(entry) {
    return entry.overbookedCapacity - entry.resHoldTotal;
  }
  function addCustomClasses(newEntry) {
    if (!newEntry.customClasses) {
      newEntry.customClasses = {};
    }
    newEntry.customClasses.resHoldTotal = trendComputingService.getTrendClass(newEntry.resHoldTotal, newEntry.lastYearCurrentBookings);
    newEntry.customClasses.bookingsExpected = trendComputingService.getTrendClass(newEntry.bookingsExpected, newEntry.lastYearFinalBookings);
    newEntry.customClasses.currentLoadFactor = trendComputingService.getTrendClass(newEntry.currentLoadFactor, newEntry.lastYearCurrentLoadFactor);
    newEntry.customClasses.expectedLoadFactor = trendComputingService.getTrendClass(newEntry.expectedLoadFactor, newEntry.lastYearFinalLoadFactor);
  }
  FlightCabinGridTransformer.prototype.transform = function (data, metric, metricDescriptor) {
    setLastRefreshTime(data.domain.timeStamp);
    var dtdCriteria = metricDescriptor && metricDescriptor.params && metricDescriptor.params.dtdCriteria;
    var memorizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memorizedMomentOfEventDate = _.memoize(getMomentOfDate);
    var memorizedMomentOfArrivalTime = _.memoize(getMomentOfTime);
    var memorizedMomentOfDepartureTime = _.memoize(getMomentOfTime);
    var memoizedFormatUserActionList = _.memoize(userActionService.formatActionsList);
    var alertThreshold = hepService.getSimpleHepProperties().ALERT_THRESHOLD;
    var transformData = function transformData(legCabins, metric) {
      var result = [];
      for (var i = 0, length = legCabins.length; i < length; i++) {
        var cabin = legCabins[i];

        // skip records that contain only LY data (aka wydmuszki)
        if (_.isUndefined(cabin.flightId)) {
          continue;
        }
        var flightDepartureDateMoment = memorizedMomentOfDepartureDate(cabin.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var optGroupDateMoment = memorizedMomentOfDepartureDate(cabin.optGroupDate, momentService.FIELD.DEPARTURE_DATE);
        var legDepartureDateMoment = memorizedMomentOfDepartureDate(cabin.legDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var eventTimeStamp = memorizedMomentOfEventDate(cabin.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        var momentDepartureDateTime = memorizedMomentOfDepartureTime(cabin.departureTime, momentService.FIELD.DEPARTURE_TIME, memorizedMomentOfDepartureDate);
        var momentArrivalTime = memorizedMomentOfArrivalTime(cabin.arrivalTime, momentService.FIELD.ARRIVAL_TIME, memorizedMomentOfDepartureDate);
        var actions = memoizedFormatUserActionList(cabin.userActionList);
        var action = actions[0];
        var newEntry = {
          entryKey: cabin.carrier + cabin.leg + cabin.flightNumber + cabin.cabinCode + cabin.flightDepartureDate,
          flightId: cabin.flightId,
          entity: cabin.entity,
          referenceCurveFlightId: cabin.referenceCurveFlightId,
          legId: cabin.legId,
          scenarioName: cabin.scenarioName,
          operatingCarrier: cabin.operatingCarrier,
          carrier: cabin.carrier,
          allotment: cabin.allotment,
          arrivalTime: momentArrivalTime,
          authorizationModel: cabin.authorizationModel,
          bidPrice: cabin.bidPrice,
          boardingRate: cabin.boardingRate,
          userBoardingRate: cabin.userBoardingRate,
          cancellationRate: cabin.cancellationRate,
          userCancellationRate: cabin.userCancellationRate,
          cabinIndex: cabin.cabinIndex,
          sequence: cabin.sequence,
          cabinCode: cabin.cabinCode,
          capacityUserOverride: cabin.capacityUserOverride,
          criticality: cabin.criticality,
          daysToDeparture: cabin.daysToDeparture,
          departureDateTimeMoment: momentDepartureDateTime,
          equipment: cabin.equipment,
          aircraftConfig: cabin.aircraftConfig,
          saleableConfig: cabin.saleableConfig,
          optimalCabinOption: cabin.optimalCabinOption,
          flightDepartureDateMoment: flightDepartureDateMoment,
          optGroupDateMoment: optGroupDateMoment,
          flightNumber: cabin.flightNumber,
          opsSuffix: cabin.opsSuffix,
          // value is in milliseconds
          eventTimeStamp: eventTimeStamp,
          lastProcessedDateMoment: eventTimeStamp,
          cabinWaitList: cabin.cumulativeCabinWaitList,
          leg: cabin.leg,
          legCabinId: cabin.legCabinId,
          legDepartureDateMoment: legDepartureDateMoment,
          legDistance: cabin.legDistance,
          logicalModelCapacity: cabin.logicalModelCapacity,
          userLogicalModelCapacity: cabin.userLogicalModelCapacity,
          maxUpgrades: cabin.maxUpgrades,
          userMaxUpgrades: cabin.userMaxUpgrades,
          maxDowngrades: cabin.maxDowngrades,
          userMaxDowngrades: cabin.userMaxDowngrades,
          lowestClassOpen: cabin.lowestClassOpen,
          overbookedCapacity: cabin.overbookedCapacity,
          overbookingPercentageModel: cabin.overbookingPercentageModel,
          userOverbookingPercentageModel: cabin.userOverbookingPercentageModel,
          overSaleRiskLevel: cabin.overSaleRiskLevel,
          userOverSaleRiskLevel: cabin.userOverSaleRiskLevel,
          physicalCapacity: cabin.physicalCapacity,
          remainingDemandFC: cabin.remainingDemandFC + cabin.remainingMappedDemandFC,
          legLoadFactor: cabin.legLoadFactor,
          season: cabin.season,
          seasonOverride: cabin.userSeasonOverride,
          dowGroup: cabin.dowGroup,
          seatsAvailableModel: cabin.seatsAvailableModel,
          showUpRateIX: cabin.showUpRateIX,
          showUpRateBlended: cabin.showUpRateBlended,
          userShowUpRateBlended: cabin.userShowUpRateBlended,
          emsrSlack: cabin.emsrSlack,
          spoilageCost: cabin.spoilageCost,
          userNotes: cabin.userNotes,
          liveIdvBkgs: cabin.invResHoldIdv,
          liveGrpBkgs: cabin.invResHoldGroup,
          liveTotalBkgs: cabin.invResHoldTotal,
          groupMaterializationRate: cabin.groupMaterializationRate,
          userGroupMaterializationRate: cabin.userGroupMaterializationRate,
          isManuallyControlled: cabin.isManuallyControlled,
          userIsManuallyControlled: cabin.userIsManuallyControlled,
          appliedRules: cabin.appliedRules,
          departureDateDOW: cabin.departureDateDOW.substr(0, 3),
          alerts: cabin.alertScore,
          topAlert: cabin.topAlertName,
          numberOfAlertRulesApplied: cabin.numberOfAlertRulesApplied,
          alertThresholdExceeded: cabin.alertScore > alertThreshold,
          latestChanges: cabin.latestChanges,
          appliedRulesNumber: cabin.appliedRules.length,
          flightTags: cabin.flightTags ? cabin.flightTags.toString() : undefined,
          actions: actions,
          actionType: _.get(action, 'type'),
          actionTime: _.get(action, 'time'),
          actionUser: _.get(action, 'user')
        };
        var fieldsToRewrite = ['loadFactor', 'bookingsCabin', 'revenueCabin', 'revenuePaxDistance', 'revenueAvailableSeatDistance', 'availableSeatDistance'];
        var metricValues = metricReferenceDataService.getMetricsDataForGrid(cabin, fieldsToRewrite);
        var entryWithMetrics = _.extend(newEntry, metricValues);
        entryWithMetrics.inventoryCabinAvailability = getInvCabinAvailability(entryWithMetrics);
        if (metric === true) {
          addCustomClasses(entryWithMetrics);
        }
        bookingsIntakeTransformationService.calculateBookingsIntake(entryWithMetrics, cabin);
        setEffectiveValues(entryWithMetrics);
        result.push(entryWithMetrics);
      }
      return result;
    };
    var legCabins = data.domain.legCabins || data.domain.results;
    var legCabinsScenario = data.secondDomain && (data.secondDomain.legCabins || data.secondDomain.results) || [];
    var fileteredLegCabins = dtdCriteria && dtdCriteria.length ? dtdFilteringService.filterByDtd(legCabins, dtdCriteria) : legCabins;
    var fileteredLegCabinsScenario = dtdCriteria && dtdCriteria.length ? dtdFilteringService.filterByDtd(legCabinsScenario, dtdCriteria) : legCabinsScenario;
    var transformedProductionData = transformData(fileteredLegCabins, metric);
    var transformedScenarioData = transformData(fileteredLegCabinsScenario, metric);
    return mergeScenarioDataService.merge(transformedProductionData, transformedScenarioData);
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  function getMomentOfTime(date, field, memorizedMomentOfDate) {
    return memorizedMomentOfDate(date, field, 'HHmm');
  }
  return FlightCabinGridTransformer;
};
FlightCabinGridTransformerFactory.$inject = ['DataTransformerFactory', 'MergeScenarioDataService', 'BookingsIntakeTransformationService', 'CalculateEffectiveValueService', 'MomentService', 'UserActionService', 'HepService', 'DtdFilteringService', 'FlightLiveDataService', 'TrendComputingService', 'UserProcessingTransformationService', 'MetricReferenceDataService'];
module.exports = FlightCabinGridTransformerFactory;